<template>
  <g fill="none" stroke="#333333">
    <path d="M1 9 L17 9" />
    <path d="M9 1 L9 17" />
    <circle cx="9" cy="9" r="5" />
  </g>
</template>
